import { useEffect, useRef } from 'react';

/**
 * Clears selection and returns pagination to page 1 when {@link filterKey} changes.
 * Skips the initial mount so remounting with the same key does not wipe selection.
 */
export const useResetOnFilterKeyChange = (
  filterKey: string,
  resetSelection: () => void,
  setPage: (page: number) => void,
  clearExpandedRows?: () => void
): void => {
  const prevFilterKeyRef = useRef(filterKey);

  useEffect(() => {
    if (prevFilterKeyRef.current === filterKey) return;
    prevFilterKeyRef.current = filterKey;
    resetSelection();
    setPage(1);
    clearExpandedRows?.();
  }, [filterKey, resetSelection, setPage, clearExpandedRows]);
};
